import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  REQUEST_QUALIFICATION,
  REQUEST_QUALIFICATION_FAILURE,
  REQUEST_QUALIFICATION_SUCCESS,
} from '../constants/ActionTypes';

import { STRING } from '../constants/DataTypes';
import { fields, detailFields, entityMap } from '../constants/fields/EmployeeMasterQualification';

export function mapQualification(q) {
  return {
    fields,
    detailFields,
    entityMap,
    Entity: q.Entity,
    HrQualificationScaleID: {
      value: q.HrQualificationScaleID,
      entity: 'HrQualificationScaleID',
    },
    QualificationTypeName: {
      label: <FormattedMessage id="qualification.type" />,
      value: q.QualificationTypeName,
      type: STRING,
      entity: 'QualificationType',
    },
    QualificationName: {
      label: <FormattedMessage id="qualification.name" />,
      value: q.QualificationName,
      type: STRING,
      entity: 'HrQualificationID',
    },
    HrQualificationScaleEntryName: {
      label: <FormattedMessage id="qualification.scale" />,
      value: q.HrQualificationScaleEntryName,
      type: STRING,
      entity: 'HrQualificationScaleEntryID',
    },
  };
}

export default function qualificationReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_QUALIFICATION:
      return {
        ...state,
        loaded: false,
        isFetching: true,
        qualificationData: [],
      };

    case REQUEST_QUALIFICATION_FAILURE:
      return {
        ...state,
        loaded: true,
        isFetching: false,
        error: action.error,
        qualificationData: [],
      };

    case REQUEST_QUALIFICATION_SUCCESS:
      return {
        ...state,
        loaded: true,
        isFetching: false,
        lastUpdated: action.receivedAt,
        qualificationData: action.qualificationData.map(mapQualification),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/qualificationReducer.js